import { cn } from '@/shared/lib'

type Props = {
  className?: string
  size?: 'default' | 'large' | 'small' | 'xsmall'
}

export const Spinner = ({ className, size = 'default' }: Props) => (
  <div
    className={cn(
      'absolute top-0 left-0 flex h-full w-full items-center justify-center',
      className,
    )}
  >
    <div
      className={cn('loader', {
        large: size === 'large',
        small: size === 'small',
        xsmall: size === 'xsmall',
      })}
    />
  </div>
)
